import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Slide } from '@material-ui/core';

import { MUIModal, Flex, Image, Text } from 'Components/Base';

import loadingIndicatorGIF from '../../../../../public/assets/images/quiz/gamification-loading.gif';

const BACKGROUND_COLOR = '#4D4D4D';
const TRANSITION_DELAY = 1000;

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
Transition.displayName = 'Transition';

const modalContentStyle = makeStyles({
  root: () => ({
    padding: '0px',
    overflow: 'hidden',
  }),
});

const modalStyle = makeStyles((theme) => {
  return {
    paper: () => ({
      padding: '0px',
      height: '673px',
      width: '327px',
      borderRadius: '8px',
      backgroundColor: BACKGROUND_COLOR,
      '& #close-icon': {
        opacity: 1,
        '& svg': {
          fill: 'white',
        },
        '& :hover': {
          fill: theme?.palette?.grey['900'],
        },
      },
    }),
  };
});

const GamificationModalView = ({
  isOpen,
  onOpenModal,
  onCloseModal,
  isTimerDone,
  gamificationUrl,
}) => {
  const modalClasses = modalStyle();
  const modalContentStyleClasses = modalContentStyle();
  const modalCardStyle = { height: '100%' };

  return (
    <MUIModal
      TransitionComponent={Transition}
      transitionDuration={TRANSITION_DELAY}
      open={isOpen}
      modalContentProps={{ classes: modalContentStyleClasses }}
      innerProps={{ ...modalCardStyle }}
      classes={modalClasses}
      onOpenModal={onOpenModal}
      onCloseModal={onCloseModal}
      closeIcon
      disableBackdropClick
    >
      {isTimerDone && gamificationUrl ? (
        <iframe
          src={gamificationUrl}
          title={'Gamification Web View'}
          frameBorder="0"
          style={{
            width: '100%',
            height: '100%',
            border: 0,
            padding: 0,
            margin: 0,
            overflow: 'none',
          }}
        ></iframe>
      ) : (
        <Flex
          style={{ height: '100%', backgroundColor: BACKGROUND_COLOR }}
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Image src={loadingIndicatorGIF} />
          <Text fontSize={5} color="white">
            Loading...
          </Text>
        </Flex>
      )}
    </MUIModal>
  );
};

GamificationModalView.propTypes = {
  isOpen: PropTypes.bool,
  onOpenModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  isTimerDone: PropTypes.bool,
  gamificationUrl: PropTypes.string,
};

export default GamificationModalView;
